import { render, staticRenderFns } from "./FooterLegal.vue?vue&type=template&id=2c4bfed2&scoped=true&"
import script from "./FooterLegal.vue?vue&type=script&lang=js&"
export * from "./FooterLegal.vue?vue&type=script&lang=js&"
import style0 from "./FooterLegal.vue?vue&type=style&index=0&id=2c4bfed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bfed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFooter,VRow})
